import React from 'react';
import Product from './Product';

export default (props) => <Product {...props}/>;
